import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/ui/PageWrapper';
import FadeUp from '../components/ui/FadeUp';
import CTASection from '../components/sections/CTASection';

const courses = [
  {
    level: 'Beginner', title: 'Vastu Shastra Fundamentals',
    duration: '4 Weeks', mode: 'Online', price: '₹8,999',
    desc: 'Learn the basics of Vastu Shastra — the five elements, eight directions, and fundamental principles.',
    topics: ['Five elements (Pancha Bhuta)', 'Eight directions & their significance', 'Basic floor plan analysis', 'Simple home remedies']
  },
  {
    level: 'Intermediate', title: 'Advanced Vastu Analysis',
    duration: '8 Weeks', mode: 'Online + Offline', price: '₹18,999',
    desc: 'Deep dive into advanced Vastu concepts including the 12-type audit system and commercial applications.',
    topics: ['12-type audit methodology', 'Commercial Vastu', 'Yantra & crystal remedies', 'Case study analysis']
  },
  {
    level: 'Professional', title: 'Vastu Consultant Certification',
    duration: '3 Months', mode: 'Offline (Thane)', price: '₹45,999',
    desc: 'Become a certified Vastu consultant with Dr. Ahirrao\'s comprehensive professional training program.',
    topics: ['Complete Vastu Shastra mastery', 'Client consultation skills', 'Business setup guidance', 'Certificate from Dr. Ahirrao']
  },
];

export default function Courses() {
  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 40% 60%, rgba(232,135,26,0.06) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">Learn from the Expert</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}>Vastu Courses</h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 560, lineHeight: 1.8 }}>
              Learn authentic Vastu Shastra directly from Raghav Taparia — Ph.D., Gold Medallist and 20+ years practitioner.
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 28 }}>
            {courses.map((c, i) => (
              <FadeUp key={i} delay={i * 0.15}>
                <div style={{
                  background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.15)',
                  borderRadius: 16, padding: '36px 28px', height: '100%',
                  display: 'flex', flexDirection: 'column'
                }}>
                  <div style={{
                    display: 'inline-block', padding: '4px 12px', borderRadius: 20,
                    background: 'rgba(232,135,26,0.1)', border: '1px solid rgba(232,135,26,0.2)',
                    fontSize: 11, color: '#E8871A', letterSpacing: 2, marginBottom: 20, alignSelf: 'flex-start'
                  }}>
                    {c.level.toUpperCase()}
                  </div>
                  <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 22, marginBottom: 12 }}>{c.title}</h2>
                  <p style={{ fontSize: 14, opacity: 0.65, lineHeight: 1.7, marginBottom: 20 }}>{c.desc}</p>
                  <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
                    {[`⏱ ${c.duration}`, `📍 ${c.mode}`].map((tag, j) => (
                      <span key={j} style={{ fontSize: 12, opacity: 0.6, background: 'rgba(255,255,255,0.04)', padding: '4px 10px', borderRadius: 4 }}>
                        {tag}
                      </span>
                    ))}
                  </div>
                  <ul style={{ listStyle: 'none', marginBottom: 28, flex: 1 }}>
                    {c.topics.map((t, j) => (
                      <li key={j} style={{ fontSize: 13, opacity: 0.7, marginBottom: 8, display: 'flex', gap: 8 }}>
                        <span style={{ color: '#E8871A' }}>✦</span> {t}
                      </li>
                    ))}
                  </ul>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 24, color: '#E8871A' }}>{c.price}</p>
                    <Link to="/contact" className="btn-primary" style={{ fontSize: 13, padding: '10px 20px' }}>
                      Enroll Now
                    </Link>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp style={{ marginTop: 64 }}>
            <div style={{
              background: 'rgba(232,135,26,0.04)', border: '1px solid rgba(232,135,26,0.15)',
              borderRadius: 16, padding: '48px 40px', textAlign: 'center'
            }}>
              <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 26, marginBottom: 16 }}>
                Also Offering: Reiki & Energy Healing
              </h2>
              <p style={{ fontSize: 15, opacity: 0.7, maxWidth: 560, margin: '0 auto 28px', lineHeight: 1.8 }}>
                Complement your Vastu journey with Reiki and pranic energy healing courses. Learn to cleanse and energise spaces and people.
              </p>
              <Link to="/contact" className="btn-outline">Enquire About Reiki Courses</Link>
            </div>
          </FadeUp>
        </div>
      </section>

      <CTASection />
    </PageWrapper>
  );
}
